"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectCostCodesSelectField = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var MenuItem_1 = __importDefault(require("@material-ui/core/MenuItem"));
var icons_1 = require("@material-ui/icons");
var react_query_1 = require("react-query");
var react_common_lib_1 = require("@esub-engineering/react-common-lib");
var react_component_library_1 = require("@esub-engineering/react-component-library");
var GraphQLClient_1 = require("../../GraphQLClient");
var ControlledSelectField_1 = require("../ControlledSelectField");
var styles_1 = __importDefault(require("./styles"));
var types_1 = require("../types");
var materialColors = react_component_library_1.themes.materialColors;
exports.ProjectCostCodesSelectField = react_1.default.memo(function (_a) {
    var _b, _c;
    var selectedProjectId = _a.selectedProjectId, companyId = _a.companyId, categories = _a.categories, variant = _a.variant, enclosedTextFieldProps = _a.enclosedTextFieldProps, _d = _a.value, value = _d === void 0 ? '' : _d, rest = __rest(_a, ["selectedProjectId", "companyId", "categories", "variant", "enclosedTextFieldProps", "value"]);
    var key = react_common_lib_1.costCodeQueries.key, searchCostCodes = react_common_lib_1.costCodeQueries.searchCostCodes;
    var client = (0, GraphQLClient_1.useGraphQLClient)();
    var queryCostCodes = (0, react_1.useCallback)(function () {
        return client.request(searchCostCodes, {
            direction: 'ASC',
            limit: 100,
            filter: __assign({ status: { contains: types_1.CostCodeStatus.ACTIVE }, companies: {
                    id: {
                        eq: companyId,
                    },
                }, projects: { id: { eq: selectedProjectId } }, type: {
                    eq: 'PROJECT',
                } }, (categories
                ? {
                    categories: {
                        contains: categories,
                    },
                }
                : {})),
            page: 1,
            sortBy: 'NUMBER',
        }, {});
    }, [categories, client, companyId, searchCostCodes, selectedProjectId]);
    var _e = (0, react_query_1.useQuery)([key, categories], queryCostCodes, {
        refetchOnWindowFocus: false,
    }), data = _e.data, error = _e.error, isLoading = _e.isFetching;
    var classes = (0, styles_1.default)();
    return ((0, jsx_runtime_1.jsxs)(ControlledSelectField_1.ControlledSelectField, __assign({ helperText: error ? 'Unable to retrieve project cost codes' : '', defaultValue: value, disabled: isLoading, SelectProps: {
            IconComponent: isLoading ? icons_1.Autorenew : icons_1.ArrowDropDown,
        }, select: true, variant: variant }, rest, enclosedTextFieldProps, { children: [value === '0' && ((0, jsx_runtime_1.jsx)(MenuItem_1.default, __assign({ value: "0", style: { color: materialColors.grey[100], backgroundColor: 'white' } }, { children: "Select One" }), "0")), (_c = (_b = data === null || data === void 0 ? void 0 : data.searchCostCodes) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.map(function (costCode) { return ((0, jsx_runtime_1.jsxs)(MenuItem_1.default, __assign({ className: classes.root, value: costCode.document.entity.number }, { children: [costCode.document.entity.number, " ", costCode.document.entity.name] }), costCode.document.entity.id)); })] })));
});
